import React from 'react';
import { Modal, Button, Tag, Descriptions, Divider, Spin, Alert } from 'antd';
import { useUserDetailModalStore } from '@/stores/userDetailModal';
import { useUserEditModalStore } from '@/stores/userEditModal';
import { useUserPermissionModalStore } from '@/stores/userPermissionModal';
import { OperationList } from '@/components/OperationList';

const roleColors = {
  admin: 'red',
  manager: 'blue',
  auditor: 'green',
  user: 'default',
};

const GlobalUserDetailModal: React.FC = () => {
  const { isOpen, user, loading, error, closeUserDetail } = useUserDetailModalStore();
  const { openUserEdit } = useUserEditModalStore();
  const { openUserPermission } = useUserPermissionModalStore();

  const handleEdit = () => {
    if (user) {
      openUserEdit(user);
      closeUserDetail();
    }
  };

  const handleViewPermissions = () => {
    if (user) {
      openUserPermission(user.id);
    }
  };

  return (
    <Modal
      title="用户详情"
      open={isOpen}
      onCancel={closeUserDetail}
      footer={[
        <Button key="permissions" type="default" onClick={handleViewPermissions} disabled={!user || loading}>
          查看权限
        </Button>,
        <Button key="edit" type="primary" onClick={handleEdit} disabled={!user || loading}>
          编辑
        </Button>,
      ]}
      width={800}
      destroyOnClose
    >
      <Spin spinning={loading}>
        {error && <Alert message="获取用户信息失败" description={error} type="error" style={{ marginBottom: 16 }} showIcon />}

        {user && (
          <div>
            <Descriptions column={1} labelStyle={{ width: '120px' }}>
              <Descriptions.Item label="姓名">{user.username}</Descriptions.Item>
              <Descriptions.Item label="邮箱">{user.email || '-'}</Descriptions.Item>
              <Descriptions.Item label="电话">{user.phone || '-'}</Descriptions.Item>
              <Descriptions.Item label="组织">{user.organization?.organization_name || '-'}</Descriptions.Item>
              <Descriptions.Item label="角色">
                <div>
                  {user.roles && user.roles.length > 0
                    ? user.roles.map((role) => (
                        <Tag key={role.id} color={roleColors[role.role_name as keyof typeof roleColors] || 'default'}>
                          {role.role_name}
                        </Tag>
                      ))
                    : '-'}
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="状态">
                <Tag color={user.status === 0 ? 'green' : 'red'}>{user.status === 0 ? '激活' : '停用'}</Tag>
              </Descriptions.Item>
              <Descriptions.Item label="描述">{user.describe || '-'}</Descriptions.Item>
            </Descriptions>

            <Divider />

            <OperationList user_id={user.id} />
          </div>
        )}

        {!loading && !error && !user && (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <span>暂无用户数据</span>
          </div>
        )}
      </Spin>
    </Modal>
  );
};

export default GlobalUserDetailModal;
